module.exports = __webpack_public_path__ + "static/media/12.96b1e87f.jpg";